<template>
  <div class="detail">
    <div class="title flex flex-y-center container">
      <span @click="indexHandle()">
        <img src="../../assets/images/home.png" alt />首页
      </span>
      <span v-for="(item,index) in this.pathList" :key="index" @click="navHandle(item)">
        <i>></i>
        {{ item.strName }}
      </span>
    </div>
    <div class="container">
      <!-- <h2 v-html="detailInfo.strMasTitle"></h2> -->
      
      <!-- 大会发言的 副标题 口头、书面 放标题左侧 -->
      <template v-if="detailInfo.strColId ==='ca24c4c096d349659a1c88fbbc6b4f83' ">
        <h2 >
        <span v-html="detailInfo.strSecTitle"></span>
        <span v-html="detailInfo.strMasTitle"></span>
        </h2>
        </template>
        <template v-if="detailInfo.strColId !=='ca24c4c096d349659a1c88fbbc6b4f83' ">
          <h2 class="new-title first-title" v-html="detailInfo.strMasTitle">}</h2>
          <h3 class="secTitle" v-html="detailInfo.strSecTitle"></h3>
          <!-- <span
          v-if="detailInfo.strSecTitle"
          class="sec-title"
          v-html="detailInfo.strSecTitle"
          >
          </span> -->
        </template> 

      <div class="information">
        <span class="ml">日期：{{ detailInfo.strPubDate | formatDate }}</span>
        <span class="ml">来源：{{ detailInfo.strSource }}</span>

      </div>

      <div class="content-wrap" v-html="detailInfo.strContent"></div>

    </div>
  </div>
</template>

<script>
import { detailData } from "@/api/configuration";
import { get } from "../../utils/helpers";
export default {
  name: "Detail",
  props: {},
  filters: {
    formatDate (val) {
      if (!val) return "";
      return val.split(" ")[0];
    }
  },
  data () {
    return {
      colorAct: null,
      pathList: [], //面包屑导航
      detailInfo: {}, //详情
      visionColor: [
        "#F9F6AF",
        "#9DDBF4",
        "#DEDEDE",
        "#F9D1D9",
        "#E4C8F8",
        "#FFFFFF"
      ],
      fontList: [
        {
          value: "小",
          fontsize: "12px"
        },
        {
          value: "中",
          fontsize: "14px"
        },
        {
          value: "大",
          fontsize: "16px"
        }
      ]
    };
  },
  created () {
    this.getDetailData();
  },
  methods: {
    // 大小字体高亮
    changColor (i) {
      this.colorAct = i;
    },
    //获取详情数据
    getDetailData () {
      var param = {
        strId: this.$route.query.strId,
        strWebSiteId: this.$route.query.strWebSiteId
      };
      detailData(param)
        .then(res => {
          // 处理面包屑导航
          let colPathList = get(["data", "objList", "colPathList"], res.data);

          for (const key in colPathList) {
            this.pathList.push(colPathList[key]);
          }
          this.pathList.splice(0, 1);
          // 获取内容详情
          this.detailInfo = get(["data", "objList", "info"], res.data);
          // console.log(this.detailInfo.strContent, "res.data");
          this.detailInfo.strMasTitle = this.detailInfo.strMasTitle.replace(/[\n]+/g, '<br/>')
          document.title = get(
            ["data", "objList", "info", "strMasTitle"],
            res.data
          ).replace(/<[^>]+>/g, "");
        })
        .catch(err => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },

    // 首页跳转
    indexHandle () {
      this.$router.push({
        path: "/index",
        query: { strWebSiteId: this.$route.query.strWebSiteId }
      });
    },
    // 菜单跳转
    navHandle (item) {
      this.$router.push({
        path: "/list",
        query: {
          strId: item.strId,
          strWebSiteId: this.$route.query.strWebSiteId
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.detail {
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .title {
    line-height: 50px;
    position: relative;
    border-bottom: 2px solid #eaeaea;
    span {
      margin: 0;
      padding: 0;
      color: #4a4a4a;
      font-size: 1em;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        color: #d70000;
      }
      img {
        margin: 0 6px 0 0;
      }
      i {
        font-style: normal;
        margin: 0 6px;
        font-family: serif;
      }
    }
  }
  h2 {
    color: #dc0000;
    font-weight: bold;
    text-align: center;
    font-size: 32px;
    line-height: 56px;
    padding: 25px 0;
    margin: 0;
  }
  .information {
    display: flex;
    font-weight: normal;
    font-size: 14px;
    color: #000;
    justify-content: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 2px solid #eaeaea;
    .font {
      .font-item {
        margin-right: 10px;
      }
    }
    .vision {
      .vision-item {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 5px;
        cursor: pointer;
      }
    }
    .ml {
      margin-right: 30px;
      cursor: pointer;
    }
    .redcolor {
      color: red !important;
    }
  }
  .speech {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }
  .content-wrap {
    border-bottom: 2px solid #e5e5e5;
    box-sizing: border-box;
    padding: 0 30px;
  }
  .page {
    padding-top: 20px;
    .previous {
      margin-bottom: 10px;
      .previous-left {
        display: inline-block;
        background-color: red;
        color: #fff;
        padding: 3px 10px;
        margin-right: 10px;
      }
    }
  }
}
.detail .secTitle{
  color: #dc0000;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  line-height: 56px;
  padding: 0 0 25px 0;
  margin: 0;
}
.detail .container {
.new-title {
  padding: 0;
}
.first-title{
  padding-top: 25px;
}
}
</style>